export function BacklogIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3668 12.9C15.3668 15.3038 15.3668 16.5066 14.6196 17.2529C13.8733 18 12.6706 18 10.2668 18H8.5668C6.163 18 4.96025 18 4.21395 17.2529C3.4668 16.5066 3.4668 15.3038 3.4668 12.9V9.5M3.4668 6.1C3.4668 3.6962 3.4668 2.49345 4.21395 1.74715C4.96025 1 6.163 1 8.5668 1H10.2668C12.6706 1 13.8733 1 14.6196 1.74715C15.3668 2.49345 15.3668 3.6962 15.3668 6.1V9.5"
        stroke="#DFDFDF"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3.46675 2.76465C2.638 2.84625 2.0804 3.0307 1.6639 3.4472C0.916748 4.1935 0.916748 5.39625 0.916748 7.80005V11.2C0.916748 13.6038 0.916748 14.8066 1.6639 15.5529C2.0804 15.9694 2.638 16.1538 3.46675 16.2354M15.3667 2.76465C16.1955 2.84625 16.7531 3.0307 17.1696 3.4472C17.9167 4.1935 17.9167 5.39625 17.9167 7.80005V11.2C17.9167 13.6038 17.9167 14.8066 17.1696 15.5529C16.7531 15.9694 16.1955 16.1538 15.3667 16.2354"
        stroke="#DFDFDF"
        stroke-width="1.5"
      />
      <path
        d="M6.8667 10.35H11.9667M6.8667 6.94995H11.9667M6.8667 13.75H9.4167"
        stroke="#DFDFDF"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
